let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dgQWQ")).then(() => parcelRequire('bDl1z'));